<template>
  <v-form
    id="signUpForm"
    ref="signUpForm"
    onsubmit="validate"
  >
    <v-card-text style="height: 320px; overflow-y: scroll; overflow-x: hidden; flex-grow: 1">
      <v-row>
        <v-col cols="5">
          <PolteqTextField
            v-model="firstname"
            field-id="firstNameField"
            :label="i18n.t('fields.firstName')"
            :rules="[rules.required]"
            type="text"
          />
        </v-col>
        <v-col>
          <PolteqTextField
            v-model="lastname"
            field-id="lastNameField"
            :label="i18n.t('fields.lastName')"
            :rules="[rules.required]"
            type="text"
          />
        </v-col>
      </v-row>
      <PolteqTextField
        v-model="company"
        field-id="companyNameField"
        :label="i18n.t('fields.company')"
        type="text"
      />
      <PolteqTextField
        v-model="emailaddress"
        field-id="emailAddressField"
        :label="i18n.t('fields.emailaddress')"
        :rules="[rules.required, rules.email]"
        type="email"
        autocomplete="username"
      />
      <PolteqTextField
        v-model="phonenumber"
        field-id="phoneNumberField"
        :label="i18n.t('fields.phonenumber')"
        :rules="[rules.phone_number]"
        type="tel"
        autocomplete="phonenumber"
      />
      <PolteqTextField
        v-model="newpassword"
        field-id="passwordField"
        :label="i18n.t('fields.password')"
        :rules="[rules.password]"
        type="password"
        autocomplete="new-password"
      />
      <PolteqTextField
        v-model="confirm"
        field-id="confirmPasswordField"
        :label="i18n.t('fields.confirmpassword')"
        :rules="[rules.password_match(newpassword, confirm)]"
        type="password"
        autocomplete="new-password"
      />
    </v-card-text>
    <v-card-text style="text-align: end">
      <PolteqButton
        button-id="signUpButton"
        icon="mdi-account-plus-outline"
        :button-text="i18n.t('buttons.signup')"
        @click="signUp(firstname, lastname, company, emailaddress, phonenumber, newpassword)"
      />
    </v-card-text>
  </v-form>
</template>

<script lang="ts" src="./SignUpForm.ts" />
